var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('Sidebar'),_c('div',{staticClass:"layout-container"},[_c('Navbar'),_c('PageContainer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }